import React from 'react';
import { Form } from '@tribeplatform/react-components/Form';
import { T, useStaticIntl } from '@tribeplatform/react-components/i18n';
import { useCollections } from '@tribeplatform/react-sdk/hooks';
import { FormControl } from '@tribeplatform/react-ui-kit/FormControl';
import { SortableList } from '@tribeplatform/react-ui-kit/SortableList';
import { Toggle } from '@tribeplatform/react-ui-kit/Toggle';
import { useBlock } from '../../hooks/index.js';
import { CollectionsLoading } from './CollectionLoading.js';
import { getDetailedCollectionItems, viewStylesFactory } from './utils.js';
export const CollectionMenuBlockSettings = () => {
    const { block: { props: { items, viewStyle }, }, upsertProp, } = useBlock();
    const { data: collections, isLoading } = useCollections({});
    const viewStyles = useStaticIntl(viewStylesFactory);
    if (isLoading) {
        return React.createElement(CollectionsLoading, null);
    }
    if (!Array.isArray(collections)) {
        return null;
    }
    const collectionItems = getDetailedCollectionItems(items, collections);
    const toggleItem = (index, enabled) => {
        const newItems = collectionItems.map((item, idx) => idx === index ? Object.assign(Object.assign({}, item), { enabled }) : item);
        upsertProp('items', newItems);
    };
    const onDragEnd = result => {
        if (!result.destination) {
            return;
        }
        const newItems = SortableList.reorder(collectionItems, result.source.index, result.destination.index);
        upsertProp('items', newItems);
    };
    return (React.createElement(Form, { onChange: e => {
            const target = e === null || e === void 0 ? void 0 : e.target;
            upsertProp(target.name, target.value);
        }, defaultValues: {
            viewStyle: viewStyle || 'collapsible',
        }, className: "flex flex-col space-y-5" },
        React.createElement(FormControl.Select, { name: "viewStyle", value: viewStyle, onChange: (value) => {
                upsertProp('viewStyle', value);
                return value;
            }, label: React.createElement(T, { id: "Generics.ViewStyle", defaultMessage: "View style" }), items: viewStyles }),
        React.createElement(FormControl, null,
            React.createElement(FormControl.Label, null,
                React.createElement(T, { id: "Generics.Collections", defaultMessage: "{COLLECTIONS_CC}" })),
            React.createElement(SortableList, { id: "main-menu-items", onDragEnd: onDragEnd, items: collectionItems, renderItem: (item, index) => (React.createElement(SortableList.Item, { id: item.id },
                    React.createElement(SortableList.DefaultView, null,
                        React.createElement("p", { className: "flex flex-grow text-content-subdued overflow-hidden" },
                            React.createElement("span", { className: "truncate" }, item.name)),
                        React.createElement(Toggle, { checked: item.enabled, onChange: enabled => {
                                toggleItem(index, enabled);
                            } })))) }))));
};
//# sourceMappingURL=Settings.js.map